import { gql } from "@apollo/client"

export const Logout = gql`
  mutation Logout($input: LogoutInput!) {
    logout(input: $input) {
      errors
    }
  }
`

export const Account = gql`
  query Account {
    me {
      emailAddress
      fullName
      mobilePhoneNumber
      loginMethods
      recentParkingSessionPurchases {
        sessionStartTime
        sessionEndTime
        vehiclePlateNumber
        spaceNumber
        purchaseAmount
        purchaseTime
        parkingCompany
        invoiceNumber
        purchaseProductType
        purchaseStatus
        purchaseType
      }
    }
  }
`
